import React, { Component } from 'react';
import { getEWManagementPoints, getTrendChartCategory } from './util/util';
import { isEmpty } from '../Common/Common';
import trend_icon from '../../Images/Daikin_Images/image/TrendGraph.png'
import energy_icon from '../../Images/Daikin_Images/image/EnergyManagement.png'
import water_icon from '../../Images/Daikin_Images/image/WaterManagement.png'
import op_info_icon from '../../Images/Daikin_Images/image/OperationManagement.png';
import error_info_icon from '../../Images/Daikin_Images/image/ErrorManagement.png';
import report_settings_icon from '../../Images/Daikin_Images/image/ReportSetting.png';
import billing_icon from '../../Images/Daikin_Images/image/Billing.png';
import realtime_icon from '../../Images/Daikin_Images/image/RTM.png';
import ppd_data from '../../Images/Daikin_Images/image/PPDData.png';

export default class Reports extends Component {
	constructor(props) {
		super(props);
		let today = new Date();
		this.search_date = today; // Also the search_start_date
		this.search_end_date = today;
		this.search_points = [];

		this.state = {

		}

		// To determine report type eg. 'energy_management' or 'water_management'
		this.report_type = '';
	}


	handleTrendGraph = () => {
		window.app.showLoading();
		this.props.receiver.getTrendPointList();
	}

	handleEnergyWaterManagement = (report_type) => {
		window.app.showLoading();
		this.report_type = report_type;
		// Calls loadReportSettings() in case App has been opened for too long
		this.props.receiver.loadReportSettings();
	}

	handleOperationInfo = () => {
		window.app.showLoading();
		this.report_type = 'op_info';
		// Calls loadReportSettings() in case App has been opened for too long
		this.props.receiver.loadReportSettings();
	}

	handleBilling = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Billing_Main');
	}

	handlePPDData = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('PPD_Data');
	}

	handleMalfunctionReport = () => {
		window.app.showLoading();
		this.report_type = 'err_report';
		// Calls loadReportSettings() in case App has been opened for too long
		this.props.receiver.loadReportSettings();
	}

	handleReportSettings = () => {
		window.app.showLoading();
		this.report_type = 'report_settings';
		// Calls loadReportSettings() in case App has been opened for too long
		this.props.receiver.loadReportSettings();
	}

	handleRealtime = () => {
		window.app.showLoading();
		this.report_type = 'realtime';
		// Calls loadReportSettings() in case App has been opened for too long
		this.props.receiver.loadReportSettings();
	}

	rcvOptimePointList = (optime_point_list) => {
		let end_date = new Date(this.search_date);
		end_date.setDate(end_date.getDate() + 1);

		let search_details = {
			fy: this.search_date.getFullYear(),
			fm: this.search_date.getMonth() + 1,
			fd: this.search_date.getDate(),
			ty: end_date.getFullYear(),
			tm: end_date.getMonth() + 1,
			td: end_date.getDate(),
			points: optime_point_list
		}

		this.props.receiver.getDailyOpTime(search_details);
	}

	rcvTrendPointList = (response) => {
		// [[point id,type], …]
		let points = [];
		let count = 0;
		let selected_categories = [];
		this.trend_points = [];

		if (!isEmpty(response)) {
			this.trend_points = response;
			for (let row of response) {
				let point_id = row[0];
				// maximum for points at first
				if (count > 4) {
					break;
				}

				let point_info = window.app.state.point_list[point_id];
				let category = getTrendChartCategory(point_id);

				if (category != '') {
					if ((!selected_categories.includes(category) && selected_categories.length < 2) || (selected_categories.includes(category))) {
						points.push(row);
						selected_categories.push(category);
						count++;
					}
				}
			}
		}

		this.search_date.setHours(0, 0, 0);
		this.search_end_date = new Date(this.search_date);
		this.search_end_date.setDate(this.search_end_date.getDate() + 1);

		let search_details = {
			fy: this.search_date.getFullYear(),
			fm: this.search_date.getMonth() + 1,
			fd: this.search_date.getDate(),
			fh: 0,
			fmin: 0,
			ty: this.search_end_date.getFullYear(),
			tm: this.search_end_date.getMonth() + 1,
			td: this.search_end_date.getDate(),
			th: 0,
			tmin: 0,
			points: points
		}

		this.search_points = points;

		this.props.receiver.getTrend(search_details);
	}

	rcvLoadReportSettings = (report_settings) => {
		this.report_settings = report_settings;

		if (this.report_type == 'report_settings') {
			window.app.hideLoading();
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			this.props.content_handler('Report_Settings', { report_settings: this.report_settings, from: 'Reports' });
		} else if (this.report_type == 'realtime' || this.report_type == 'RT_Energy_View') {
			this.props.receiver.getRealtimeEnergy();
		} else if (this.report_type == 'op_info') {
			this.props.receiver.getOptimePointList();
		} else if (this.report_type == 'err_report') {
			let search_details = {
				year: this.search_date.getFullYear(),
				month: this.search_date.getMonth() + 1,
				day: this.search_date.getDate(),
			}

			this.props.receiver.getDailyErrorInfo(search_details);
		} else {
			let points = getEWManagementPoints(this.report_settings.categories, this.report_type);
			let search_details = {
				year: this.search_date.getFullYear(),
				month: this.search_date.getMonth() + 1,
				day: this.search_date.getDate(),
				points: points,
			}

			this.props.receiver.getHourlyMeter(search_details);
		}
	}

	rcvReadJSONFile = (response) => {
		let categories = {};
		if (response.result == 'OK') {
			switch (response.name) {
				case 'RT_Energy_Layout.json':
					this.rt_energy_layout = response.data;
					// Calls loadReportSettings() in case App has been opened for too long
					this.props.receiver.loadReportSettings();

					return;
					break;
				default:

			}
		} else {

		}

		if (this.report_type == 'report_settings') {
			window.app.hideLoading();
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			this.props.content_handler('Report_Settings', { report_settings: response.data, from: 'Reports' });
		} else if (this.report_type == 'realtime') {
			this.props.receiver.getRealtimeEnergy();
		} else if (this.report_type == 'op_info') {
			this.props.receiver.getOptimePointList();
		} else if (this.report_type == 'err_report') {
			let search_details = {
				year: this.search_date.getFullYear(),
				month: this.search_date.getMonth() + 1,
				day: this.search_date.getDate(),
			}

			this.props.receiver.getDailyErrorInfo(search_details);
		} else {
			let points = getEWManagementPoints(categories, this.report_type);
			let search_details = {
				year: this.search_date.getFullYear(),
				month: this.search_date.getMonth() + 1,
				day: this.search_date.getDate(),
				points: points,
			}

			this.props.receiver.getHourlyMeter(search_details);
		}
	}

	rcvHourlyMeter = (hourly_meter) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Energy_Water_Management', { report_type: this.report_type, meter_info: hourly_meter, report_settings: this.report_settings, from: 'Reports', search_date: this.search_date });
	}

	rcvDailyOpTime = (daily_op_time) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Operation_Info', { op_time: daily_op_time, from: 'Reports', search_date: this.search_date, report_settings: this.report_settings });
	}

	rcvDailyErrorInfo = (daily_err_info) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Error_Info_Report', { err_info: daily_err_info, from: 'Reports', search_date: this.search_date, report_settings: this.report_settings });
	}

	rcvTrendData = (trend_data) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Trend_Data', { trend_data: trend_data, from: 'Reports', search_start_date: this.search_date, search_end_date: this.search_end_date, points: this.search_points, available_points: this.trend_points });
	}

	rcvRealtimeEnergy = (realtime_data) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Realtime', { report_settings: this.report_settings, from: 'Reports', data: realtime_data });
	}

	render() {
		const bottom_bar_height = 55;

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height - bottom_bar_height,
			overflow: 'auto',
		}

		let icon_style = {
			width: 40,
			textAlign: 'center',
		}

		let button_width = 110;

		let card_style = {
			cursor: 'pointer',
			verticalAlign: 'top',
			width: button_width,
			height: button_width,
		}

		let available_functions = this.props.receiver.active_controller.available_functions;
		let is_water_enabled = false;
		if (!isEmpty(this.props.param.report_settings)) {
			if (!isEmpty(this.props.param.report_settings.categories)) {
				if (this.props.param.report_settings.categories.is_water_consumption_enabled != null)
					is_water_enabled = this.props.param.report_settings.categories.is_water_consumption_enabled;
			}
		}

		let username = this.props.receiver.active_controller.username;
		let is_display_rtEnergyView = available_functions.rt_energy && username != 'setup' && this.props.receiver.active_controller.user_class == 'Admin'
			&& !this.props.receiver.is_mobile && this.props.receiver.app_model == 'F';

		let is_display_report_settings = available_functions.trend_graph || available_functions.energy_graph
			|| available_functions.op_report || available_functions.err_report || available_functions.rt_energy;

		return (
			<div>
				<div style={main_content_style} className='slideInDown noScrollBar'>
					<div id='system_buttons' style={{ paddingTop: 20, textAlign: 'center' }}>
						<div style={{ ...card_style, display: available_functions.trend_graph ? 'inline-block' : 'none' }} onClick={this.handleTrendGraph}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={trend_icon} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('trend_graph')}
							</span>
						</div>
						<div style={{ ...card_style, display: available_functions.energy_graph ? 'inline-block' : 'none' }} onClick={() => this.handleEnergyWaterManagement('energy_management')}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={energy_icon} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('energy_management')}
							</span>
						</div>
						<div style={{ ...card_style, display: available_functions.energy_graph && is_water_enabled ? 'inline-block' : 'none' }} onClick={() => this.handleEnergyWaterManagement('water_management')}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={water_icon} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('water_management')}
							</span>
						</div>
						<div style={{ ...card_style, display: available_functions.op_report ? 'inline-block' : 'none' }} onClick={this.handleOperationInfo}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={op_info_icon} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('operation_info_report')}
							</span>
						</div>
						<div style={{ ...card_style, display: available_functions.err_report ? 'inline-block' : 'none' }} onClick={this.handleMalfunctionReport}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={error_info_icon} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('err_reporting_report')}
							</span>
						</div>

						<div style={{ ...card_style, display: available_functions.ppd_billing ? 'inline-block' : 'none' }} onClick={this.handleBilling}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={billing_icon} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('ppd_billing')}
							</span>
						</div>

						<div style={{ ...card_style, display: available_functions.ppd || available_functions.ppd_billing ? 'inline-block' : 'none' }} onClick={this.handlePPDData}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={ppd_data} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('ppd_data_analysis')}
							</span>
						</div>

						<div style={{ ...card_style, display: available_functions.rt_energy ? 'inline-block' : 'none' }} onClick={this.handleRealtime}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={realtime_icon} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('realtime')}
							</span>
						</div>

						<div style={{ ...card_style, display: is_display_report_settings ? 'inline-block' : 'none'}} onClick={this.handleReportSettings}>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<img src={report_settings_icon} style={icon_style} />
							</div>
							<span style={{ color: this.props.colours.system_font, minHeight: 40, display: 'inline-flex', alignItems: 'center', maxWidth: 100 }}>
								{this.props.receiver.getString('report_settings')}
							</span>
						</div>
					</div>
				</div>
			</div>
		)
	}
}